"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilesSize = void 0;

// Returns the size of all files in the files object.
var getFilesSize = function getFilesSize(files) {
  return Object.keys(files).reduce(function (fileSize, key) {
    fileSize += files[key].size || 0;
    return fileSize;
  }, 0);
};

exports.getFilesSize = getFilesSize;
//# sourceMappingURL=utils.js.map